import { PendingListingCount, ValidPeriods } from './types'

export function formatPeriodText(v: ValidPeriods, prefix: string): string {
  switch (v) {
    case 'mtd':
      return `${prefix} this month`
    case 'today':
      return `${prefix} today`
    case 'last_7':
      return `${prefix} last 7 days`
    case 'last_14':
      return `${prefix} last 14 days`
    case 'last_30':
      return `${prefix} last 30 days`
    default:
      return ''
  }
}

export function sortByCount(list: PendingListingCount[]): PendingListingCount[] {
  if (list === undefined) return []
  return list?.sort((a, b) => {
    return b.count - a.count
  })
}

export function sortByChannel(list: PendingListingCount[]): PendingListingCount[] {
  if (list === undefined) return []
  return list?.sort((a, b) => {
    return a.channel.localeCompare(b.channel)
  })
}

export function showMarketName(connectedChannelList: any, key: string): boolean {
  if (connectedChannelList === undefined) return false
  const filterByKey = connectedChannelList.filter(x => x.humanReadableName === key)
  return filterByKey.length > 1
}

export function trackReviewLinkClickEvent({ marketName = 'unknown', count }: Partial<PendingListingCount>): void {
  const trackingName = 'Dashboard Review Link Clicked'
  const trackingData = {
    channelName: marketName,
    listingsCount: count
  }

  analytics.track(trackingName, trackingData)
}

export function trackNeedsAttentionLinkClickEvent({
  marketName = 'unknown',
  channel = 'unknown',
  count
}: Partial<PendingListingCount>): void {
  const trackingName = 'Dashboard Needs Attention Link Clicked'
  const trackingData = {
    channel,
    marketName,
    count
  }

  analytics.track(trackingName, trackingData)
}

export function trackNeedsAttentionListingEvent(listingType, count): void {
  const trackingName = 'Listing From Attention Required Tab'
  const trackingData = {
    listingType,
    count
  }

  analytics.track(trackingName, trackingData)
}
